import './modules/core/navigation'
import './modules/carousel'
import './modules/modal'
import './modules/lightbox'
import './modules/accordion'
import './app/enroll'

import './modules/animations/gradient'
import './modules/animations/pulse'
import './modules/animations/stats'
import './modules/animations/scroll'

/* General
   ========================================================================== */

window.addEventListener('load', () => {
	const html = document.querySelector('html');
	html.classList.remove('preload');
})



// WEBPACK FOOTER //
// ./js/main.js